import * as tslib_1 from "tslib";
import { Component, Inject } from "vue-property-decorator";
import { FormControlType } from "@cloudpivot/form/schema";
import { FormLocationControl } from "@cloudpivot/form/src/common/controls/form-location-control";
import { H3Field } from 'h3-mobile-vue';
// import SmartLocation from '../shared/mobile-smart-location/smart-location.vue'
import { FromAddressValueService } from "@cloudpivot/form/src/common/services";
import * as platform from '@cloudpivot/platform';
let InputLocation = class InputLocation extends FormLocationControl {
    get initMap() {
        return FormLocationControl.service.initMap;
    }
    onClickContent() {
        if (this.readonly || this.readonlyFormula) {
            return false;
        }
        return !this.readonly ? this.onPosition() : this.onNavigation();
    }
    get autoGetLocation() {
        if (!this.getIsNew()) {
            return false;
        }
        if (!this.controlOpts.autoGetLocation) {
            return false;
        }
        else {
            return this.controlOpts.autoGetLocation === 'true';
        }
    }
    get isDingtalk() {
        return platform.IS_DINGTALK;
    }
    get isWechat() {
        return platform.IS_WECHAT;
    }
    mounted() {
        if (this.controlOpts.displayMode === 'accurate' && !this.isEl) {
            if (this.autoGetLocation) {
                this.setCurLoction();
            }
        }
    }
    setCurLoction() {
        const formControls = this.getFormControls();
        const sheetControls = formControls.filter(res => {
            return res.type === FormControlType.Sheet;
        });
        // const l = '{"lat": 22.548602, "lng": 113.944437, "adcode": "440305", "address": "科兴科学园B栋G层16B中国建设银行(科兴微银行)", "cityName": "深圳市", "cityAdcode": "440300", "districtName": "南山区", "provinceName": "广东省", "districtAdcode": "440305", "provinceAdcode": "440000"}'
        const locationContrl = formControls.filter(res => {
            return (res.type === FormControlType.Location
                && res.options.autoGetLocation
                && res.options.autoGetLocation === 'true'
                && res.options.displayMode
                && res.options.displayMode === 'accurate');
        });
        // 
        // sheetControls.forEach((res:any) => {
        //   const locationsKeys = res.columns.map(col => {
        //       if (col.type === FormControlType.Location 
        //         && col.options.autoGetLocation 
        //         && col.options.autoGetLocation === 'true'
        //         && col.options.displayMode
        //         && col.options.displayMode === 'accurate') {
        //           return col.key
        //         }
        //     })
        //     locationsKeys.forEach(loc => {
        //       if (!loc) {
        //         return
        //       }
        //       if (res.controller.value) {
        //         res.controller.value.forEach((sheetVal,index) => {
        //           res.controller.children[index].children[loc].value = Object.assign({}, JSON.parse(l));
        //         })
        //       }
        //     })
        //     
        // });
        const range = 500;
        FormLocationControl.service.position(range, false).then((result) => {
            let adcode = '';
            if (result.cityAdCode || result.citycode) {
                adcode = result.cityAdCode || result.citycode;
            }
            if (result.districtAdCode || result.adcode) {
                adcode = result.districtAdCode || result.adcode;
            }
            const obj = {
                provinceName: result.province,
                cityName: result.city,
                districtName: result.district,
                address: result.address,
                lat: result.latitude,
                lng: result.longitude,
                adcode
            };
            console.log('当前位置=>', obj);
            FromAddressValueService.setAddressVal(result.adcode).then((value) => {
                const v = Object.assign(obj, value);
                locationContrl.forEach(res => {
                    if (res.controller) {
                        res.controller.value = Object.assign({}, v);
                    }
                });
                // 子表赋值
                sheetControls.forEach((res) => {
                    const locationsKeys = res.columns.map(col => {
                        if (col.type === FormControlType.Location
                            && col.options.autoGetLocation
                            && col.options.autoGetLocation === 'true'
                            && col.options.displayMode
                            && col.options.displayMode === 'accurate') {
                            return col.key;
                        }
                    });
                    locationsKeys.forEach(loc => {
                        if (!loc) {
                            return;
                        }
                        if (res.controller.value) {
                            res.controller.value.forEach((sheetVal, index) => {
                                res.controller.children[index].children[loc].value = Object.assign({}, v);
                            });
                        }
                    });
                });
            });
        });
    }
    //上下布局模式
    get layoutType() {
        if (this.layoutTypeFn) {
            return this.layoutTypeFn();
        }
    }
    get range() {
        let range = 500;
        if (this.controlOpts.range) {
            const rangeMapping = {
                '1km': 1000,
                '500m': 500,
                '200m': 200
            };
            range = rangeMapping[this.controlOpts.range];
        }
        return range;
    }
    onPosition() {
        this.position();
    }
    onNavigation() {
        this.navigation();
    }
    valueChange(val) {
        if (val.adcode) {
            FromAddressValueService.setAddressVal(val.adcode).then((value) => {
                this.ctrl.value = Object.assign(val, value);
            });
        }
        else {
            this.ctrl.value = null;
        }
    }
};
tslib_1.__decorate([
    Inject()
], InputLocation.prototype, "layoutTypeFn", void 0);
InputLocation = tslib_1.__decorate([
    Component({
        name: "input-location",
        components: {
            H3Field,
            SmartLocation: () => import('@cloudpivot/form/src/common/components/mobile-smart-location/smart-location.vue')
        }
    })
], InputLocation);
export default InputLocation;
